import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button, ModalWrapper, ModalCloseButton } from '../common';
import { useMoney } from '../../hooks/useMoney';
import VehicleInfoSection from './VehicleInfoSection';

const EMPTY_VEHICLE = {
  carName: '', seat: '', capacity: '', luggage: '',
  usageTimeBadge: null, basePrice: 0, waitInfo: null,
};

export default function PriceInquiryModal({ vehicleData, dateTime = '', type = '', onClose, onSelect }) {
  const { t } = useTranslation();
  const money = useMoney();
  const vd = vehicleData || EMPTY_VEHICLE;
  const basePrice = Number(vd.basePrice) || 0;
  // #35: BE 가 holiday/weekend/night 모두 합산한 surchargesTotal 을 그대로 사용.
  //      이전엔 FE 가 자체 weekend/night 만 계산해서 평일 공휴일이 누락됐음.
  const surchargesTotal = Number(vd.surchargesTotal) || 0;
  const totalWithSurcharge = basePrice + surchargesTotal;
  // BE search 실패 시 0원 대신 안내 문구 노출 — 클라이언트가 0원으로 인지하는 회귀 차단.
  const priceUnavailable = vd.priceUnavailable === true;

  return (
    <>
    <ModalWrapper maxWidth="modal-lg" padding="" gap="" className="overflow-hidden">
      {/* Header: 차량 정보 + Close */}
      <div className="flex items-center justify-between px-5 pt-5 pb-3">
        <h2 className="text-lg font-bold text-mono-900">{t('booking.vehicle_info')}</h2>
        <ModalCloseButton onClick={onClose} size="sm" />
      </div>

      {/* Vehicle info + review + price note */}
      <div className="px-5 pb-4 flex flex-col gap-3">
        <VehicleInfoSection
          images={vd.images}
          carName={vd.carName}
          usageTimeBadge={vd.usageTimeBadge}
          specs={[
            { icon: 'van', text: vd.seat },
            { icon: 'person', text: vd.capacity },
            { icon: 'bag', text: vd.luggage },
          ]}
          waitInfo={vd.waitInfo}
          /* 할증은 시스템에서 자동 계산, 차량정보 섹션에 표시 안 함 */
        />
      </div>

      {/* Bottom bar: price + select button */}
      <div className="px-4 sm:px-5 py-3 sm:py-4 border-t border-mono-200 flex items-center justify-between gap-3">
        <div className="flex flex-col sm:flex-row sm:items-center sm:gap-3">
          <span className="text-2sm sm:text-sm font-normal text-mono-900">{t('booking.estimated_payment')}</span>
          {priceUnavailable ? (
            <span className="text-2sm sm:text-sm font-medium text-orange-500">
              {t('common.price_load_failed')}
            </span>
          ) : (
            <span className="text-xl sm:text-2xl font-bold text-mono-900">
              {money(totalWithSurcharge)}{/^US\$/.test(String(money(totalWithSurcharge))) ? ' ~' : ''}
            </span>
          )}
        </div>
        <Button width="responsive-140" onClick={onSelect} disabled={priceUnavailable}>{t('common.select')}</Button>
      </div>
    </ModalWrapper>
    </>
  );
}
